import ProfilePictureGroup from './ProfilePictureGroup'

export default ProfilePictureGroup
